import axios from 'axios'

export const http = axios.create({
  baseURL: 'https://opob8qjqxl.execute-api.us-east-1.amazonaws.com/prod/account'
})